module.exports = __webpack_public_path__ + "img/artillery-wagon-base-5.8598a6f1.png";